import { CUSTOMER_FEEDBACK_SETTING, CUSTOMER_FEEDBACK_SETTING_MSB } from '@/graphql/customerFeedback';
import logger from '@/modules/Logger';

export const CustomerFeedbackSettingService = {
  msb: (teacherId, callback) => {
    logger.debug(`[CFE][CustomerFeedbackSetting] Fetched customer feedback setting from MSB GraphQL endpoint`, {
      operation: 'cfe:get-customer-feedback-setting'
    });

    return {
      client: 'msb',
      query: CUSTOMER_FEEDBACK_SETTING_MSB,
      variables() {
        return {
          teacher_id: teacherId
        };
      },
      error() {
        logger.debug(`[CFE][CustomerFeedbackSetting] Empty result from dcustomer feedback setting api MSB endpoint`, {
          operation: 'cfe:get-customer-feedback-setting',
        });
      },
      result({ data }) {
        callback(data.customer_feedback_setting || null);
      }
    };
  },

  mbti: (teacherId, callback) => {
    logger.debug(`[CFE][CustomerFeedbackSetting] Fetched customer feedback setting from MBTI GraphQL endpoint`, {
      operation: 'cfe:get-customer-feedback-setting'
    });

    return {
      client: 'mbti',
      query: CUSTOMER_FEEDBACK_SETTING,
      variables() {
        return {
          teacher_id: teacherId
        };
      },
      error() {
        logger.debug(`[CFE][CustomerFeedbackSetting] Empty result from dcustomer feedback setting api MBTI endpoint`, {
          operation: 'cfe:get-customer-feedback-setting',
        });
      },
      result({ data }) {
        callback(data.customer_feedback_setting || null);
      }
    };
  }
};

// Route legacy endpoint to MBTI, because this API does not have FuelPHP version
CustomerFeedbackSettingService.legacy = CustomerFeedbackSettingService.mbti;
